import React from 'react';

class ThankYouMessage extends React.Component {
	render() {
		const title = this.props.title || `Thank you for your answer`;
		return (
			<div style={{
				display: 'flex',
				alignItems: 'center',
				flexDirection: 'column',
				textAlign: 'center'
			}}>
				<div style={{
					fontSize: 30,
					fontWeight: 500,
					color: '#666666',
					marginLeft: 30,
					marginRight: 30,
					marginTop: 80,
					marginBottom: 28
				}}>
					{title}
				</div>
				<img style={{
					width: 100,
					height: 100
				}} src={ require('../assets/checked_grey.png') } />
			</div>
		);
	}
}

export default ThankYouMessage;


// WEBPACK FOOTER //
// ./src/components/thankyoumessage.jsx